import { Component, Inject, OnInit } from "@angular/core";
import { urlConstant } from "../../../constant/urlConstant";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../../common/commonService";
import { isAlphabet } from "../../../common/custom.validator";
import { ShareComponent } from "../../properties/share/share.component";

@Component({
  selector: "app-share-proforma-invoice",
  templateUrl: "./share-proforma-invoice.component.html",
  styleUrls: ["./share-proforma-invoice.component.scss"],
})
export class ShareProformaInvoiceComponent implements OnInit {
  shareForm;
  baseUrl: any;
  whatsappUrl: any;
  message: any;
  submitted = false;
  sendWhatsapp: boolean;
  sendEmail: boolean;
  constructor(
    public formBuilder: FormBuilder,
    public _CommonService: CommonService,
    public toasterService: ToasterService,
    public dialogRef: MatDialogRef<ShareComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shareForm = this.formBuilder.group({
      firstName: new FormControl("", [Validators.required, isAlphabet]),
      lastName: new FormControl("", [Validators.required, isAlphabet]),
      email: new FormControl("", [
        Validators.required,
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      mobile: new FormControl("", [
        Validators.required,
        Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),
      ]),
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnInit() {}
  get f() {
    return this.shareForm.controls;
  }

  send() {
    this.submitted = true;
    this.sendWhatsapp = true;
    this.sendEmail = false;
    const shareFormData = {
      email: this.shareForm.value.email,
      mobile: this.shareForm.value.mobile,
      firstName: this.shareForm.value.firstName,
      lastName: this.shareForm.value.lastName,
      properties: this.shareForm.value.properties.map((t) => t.propertyId),
    };
    this._CommonService.showLoading();
    this._CommonService
      .post(urlConstant.Property.SharePropertiesByWhatsApp, shareFormData)
      .subscribe(
        (res) => {
          this._CommonService.hideLoading();
          if (res.Status === "200") {
            this.toasterService.pop("success", "Success", res.message);
            this.baseUrl = res.data.shareProperties.linkUrl;
            this.whatsappUrl = res.data.shareProperties.whatsappUrl;
            this.message = res.data.shareProperties.message;
            window.open(
              this.whatsappUrl +
                "/send?phone=91" +
                shareFormData.mobile +
                "&text=" +
                this.message
            );
            this.dialogRef.close();
          } else {
            this.toasterService.pop("error", "Error", res.message);
          }
        },
        (error) => {
          this._CommonService.hideLoading();
          if (error != null) {
            this.toasterService.pop("error", "Error", error.message);
          }
        }
      );
  }

  sendByEmail() {
    this.submitted = true;
    this.sendEmail = true;
    this.sendWhatsapp = false;
    const shareFormData = {
      email: this.shareForm.value.email,
      mobile: this.shareForm.value.mobile,
      firstName: this.shareForm.value.firstName,
      lastName: this.shareForm.value.lastName,
      properties: this.shareForm.value.properties.map((t) => t.propertyId),
    };
    this._CommonService.showLoading();
    this._CommonService
      .post(urlConstant.Property.SharePropertiesByEmail, shareFormData)
      .subscribe(
        (res) => {
          this._CommonService.hideLoading();
          if (res.Status === "200") {
            this.toasterService.pop("success", "Success", res.message);
            this.dialogRef.close();
          } else {
            this.toasterService.pop("error", "Error", res.message);
          }
        },
        (error) => {
          this._CommonService.hideLoading();
          if (error != null) {
            this.toasterService.pop("error", "Error", error.message);
          }
        }
      );
  }
}
